
import { CommonDialog } from "../../../../Common/CommonComponents";
import DetailsModule from "../../NoShow/components/DetailsModule.vue";
import ProfileSvc from "../../../../../services/profile-svc";
let profileSvc = null;
export default {
  components: { DetailsModule, CommonDialog },
  props: {
    layout: {
      required: false,
      default: null,
      type: String,
    },
  },
  data: () => ({
    orderDetailed: null,
    loading: false,
    showDialog: false,
  }),
  computed: {
    bookingApi() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL
        ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL
        : process.env.VUE_APP_FIXIT_NO_BOOKING_URL;
    },
    isProductReservation() {
      return this.orderDetailed.products.length && !this.orderDetailed.treatments.length
    },
    isNoShow() {
      return this.orderDetailed.orderHistoryType == "noshow";
    },
    treatmentsAreBookable() {
      return (this.orderDetailed.treatments && this.orderDetailed.treatments.length && this.orderDetailed.treatments.filter(x => !x.notBookable).length !== 0)
    },
    isCancelled() {
      return this.orderDetailed.orderHistoryType === 'cancelled'
    },
    isHistoricAppointment() {
      return this.orderDetailed.orderHistoryType === 'previous-visit'
    },
    canSendReview() {
      let daysAgo = (Math.round((new Date() - new Date(this.orderDetailed.appointmentDate)) / (24 * 60 * 60 * 1000)) - 1);
      return this.orderDetailed.orderHistoryType === 'previous-visit' && this.orderDetailed.departmentRatingId === null && daysAgo <= 30
    },
    isFutureAppointment() {
      return this.orderDetailed.orderHistoryType === 'future-visit'
    },
    isLateCancelation() {
      var hours =
        (new Date(this.orderDetailed.appointmentDate) - Date.now()) /
        36e5;
      var cancellationHours = (this.orderDetailed.fairPayCancellationHours ? this.orderDetailed.fairPayCancellationHours : this.orderDetailed.cancellationHours);
      return this.orderDetailed.fairPayEnabled && (cancellationHours > hours) && hours > 0 && this.orderDetailed.orderHistoryType === 'future-visit';
    },
    isInsideGracePeriod() {
      var hoursUntilAppointment = (new Date(this.orderDetailed.appointmentDate) - Date.now()) /36e5;
      return !((this.orderDetailed.fairPayNoShowFeeGraceHours > Math.abs(hoursUntilAppointment)) && hoursUntilAppointment < 0 && this.orderDetailed.orderHistoryType === 'future-visit');
    },
    siteId() {
      return this.layout == "portal"
        ? this.$route.params.siteId
        : this.$route.query.siteId;
    },
    portalUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_URL
        : this.$config.VUE_APP_FIXIT_NO_URL
        ? this.$config.VUE_APP_FIXIT_NO_URL
        : process.env.VUE_APP_FIXIT_NO_URL;
    },
    isTpn() {
      return !!this.tpnChainId;
    },
    tpnChainId() {
      return (
        parseInt(this.$route.params.chainId || this.$route.query.chainId) || 0
      );
    },
    tpnSiteId() {
      return this.isTpn && this.salons?.length == 1
        ? this.salons[0]?.siteId
        : 0;
    },
    /**
     * Eligible to cancel:
     * New (1), Picked (2), FinishedPicking (3), or ReadyForShipment (4)
     * 
     * Not eligible:
     * Sent (5), Delivered (6), NewReturn (7), ReturnChecked (8), Credited (9), Cancelled (10)
     */
    canCancelProductOrder() {
      return !(this.isCancelled) && [1, 2, 3, 4].includes(this.orderDetailed.orderStatusId)
    },
    eligibleToCancelOrEditAppointment() {
      if (this.orderDetailed.orderHistoryType == "future-visit") {
        var appointmentDate = this.$moment(this.orderDetailed.appointmentDate);
        var today = this.$moment();
        var hoursUntilAppointment = this.$moment
          .duration(this.$moment(appointmentDate).diff(today))
          .asHours();
        return hoursUntilAppointment >= (this.orderDetailed.fairPayCancellationHours ? this.orderDetailed.fairPayCancellationHours : this.orderDetailed.cancellationHours);
      } else return false;
    },
    webId() {
      return this.orderDetailed.treatments[0]?.employeeWebId;
    },
    priceBeforeDiscounts() {
      let productsPriceOriginal = this.orderDetailed.products.map(x => x.price).reduce((partialSum, d) => {return partialSum + d}, 0)
      let treatmentsPrice = this.orderDetailed.treatments.map(x => x.price).reduce((partialSum, d) => {return partialSum + d}, 0)
      return productsPriceOriginal + treatmentsPrice
    },
    discountAmount() {
      return this.priceBeforeDiscounts - this.orderDetailed.totalPrice
    },
  },
  methods: {
    getTermsIcon() {
      if (this.isLateCancelation) return "fxt-info-circle";
      else if (this.isNoShow) return "fxt-warning";
      else if (this.orderDetailed.fairPayStatus == "PARDONED")
        return "fxt-cancel";
      else return "fxt-check";
    },
    async cancelAppointment(appointmentId) {
        this.loading = true;
        if (
          await profileSvc.CancelAppointment(
            this.bookingApi,
            this.siteId.toString(),
            this.isTpn ? "True" : "False",
            appointmentId
          )
        ) {
          await this.updateOrder()
          this.showDialog = false;
        }
        this.loading = false;
      },
    // termsLink() {
    //   var link =
    //     "https://fixit.no/bedrift/artikler/vilkaar-for-bruk-av-fixitno/";
    //   return `<a href=${link} target='_blank'>vilkår for bruk</a>`;
    // },
    // getTerms(fairPayStatus, orderHistoryType) {
    //   Date.prototype.addHours = function (h) {
    //     this.setTime(this.getTime() - h * 60 * 60 * 1000);
    //     return this;
    //   };
    //   //-----------IF FAIRPAY-------------
    //   if (this.orderDetailed.fairPayEnabled) {
    //     if (fairPayStatus && fairPayStatus !== 'UNKNOWN' && ['cancelled', 'noshow'].includes(orderHistoryType)) {
    //       switch (fairPayStatus) {
            
    //         //Time passed but not yet paid
    //         case "NEW":
    //           return this.isInsideGracePeriod ? `Tidspunktet for timen er passert og besøket er ikke betalt enda. Om du ikke har møtt til timen kan dette medføre et gebyr i henhold til våre ${this.termsLink()}.` : '';
            
    //           //Pardoned noshow
    //         case "PARDONED":
    //           return `<b>${this.orderDetailed.siteName} har trukket gebyret.</b><br> ${this.orderDetailed.siteName} har valgt å trekke tilbake ikke møtt gebyret og du slipper å betale denne gangen.`;
    //         default: return ''
    //       }
    //     } else {
    //       switch (true) {
    //         //Normal cancellation with fairpay
    //         case this.eligibleToCancelAppointment:
    //           var cancelationBeforeTime = new Date(this.orderDetailed.appointmentDate).addHours(this.orderDetailed.fairPayCancellationHours);
    //           return `Timen kan avbestilles innen ${this.$moment(cancelationBeforeTime).format("dddd DD. MMMM [kl] LT")} i henhold til våre ${this.termsLink()}. Avbestilling etter dette eller manglende oppmøte kan medføre et gebyr.`;
            
    //           //Late cancellation with fairpay
    //         case this.isLateCancelation:
    //           return `I henhold til våre ${this.termsLink()} er avbestillingsfristen utløpt.`
            
    //           //Time passed but not yet paid
    //         case orderHistoryType === 'future-visit' && this.isInsideGracePeriod:
    //           return `Tidspunktet for timen er passert og besøket er ikke betalt enda. Om du ikke har møtt til timen kan dette medføre et gebyr i henhold til våre ${this.termsLink()}.`
    //         default: return ''
    //       }
    //     }
        
    //     //-----------IF SALON TERMS AND NO FAIRPAY-------------
    //   } else if (this.orderDetailed.conditions) {
    //     return orderHistoryType === 'future-visit' ? this.orderDetailed.conditions : ''
        
    //     //-----------DEFAULT TERMS-------------
    //   } else {
    //     switch (true) {
    //         case this.eligibleToCancelAppointment:
    //           var cancelationBeforeTime = new Date(this.orderDetailed.appointmentDate).addHours(this.orderDetailed.cancellationHours);
    //           return `Timen kan avbestilles innen ${this.$moment(cancelationBeforeTime).format("dddd DD. MMMM [kl] LT")}, i henhold til våre ${this.termsLink()}.`
    //         case this.isLateCancelation:
    //           return `Det er under ${this.orderDetailed.cancellationHours} timer til den valgte behandlingen. Timen kan ikke avbestilles i henhold til våre ${termsHtml}.`
    //         default: return ''
    //       }
    //   }
    // },
    async updateOrder() {
      this.orderDetailed = await profileSvc.GetAppointmentById(
      this.bookingApi,
      this.siteId,
      this.layout == "portal"
        ? this.$route.params.orderId
        : this.$route.query.orderId,
        this.$route.params.type
    );
    }
  },
  async created() {
    this.loading = true;
    profileSvc = await ProfileSvc(this.$axios);
    this.orderDetailed = await profileSvc.GetAppointmentById(
      this.bookingApi,
      this.siteId,
      this.layout == "portal"
        ? this.$route.params.orderId
        : this.$route.query.orderId,
        this.$route.params.type
    );
    this.loading = false;
  },
  beforeDestroy() {
    profileSvc = null;
  },
};
